import { Modal } from "antd"
import { VerifyOtp } from "../components/VerifyOtp"
import { ILoginWith2FA } from "stores/auth"
import { ZIndex } from "constants/zIndex"

type Props = {
  onSuccess?: Function
  loginResponse: ILoginWith2FA
  verify2FA: (input: { code: string; generated: boolean }) => void
  isVerifying2FA: boolean
  sendCode: () => Promise<any>
  isSendingCode: boolean
}

export const VerifyOtpPrompt = ({
  onSuccess,
  loginResponse,
  verify2FA,
  isVerifying2FA,
  sendCode,
  isSendingCode,
}: Props) => {
  return (
    <Modal
      open
      footer={null}
      closable={false}
      zIndex={ZIndex.Prompt}
      className="lg:max-w-lg max-w-sm"
    >
      <div className="w-full">
        <VerifyOtp
          onSuccess={onSuccess?.()}
          loginResponse={loginResponse}
          verify2FA={verify2FA}
          isVerifying2FA={isVerifying2FA}
          sendCode={sendCode}
          isSendingCode={isSendingCode}
        />
      </div>
    </Modal>
  )
}
